"use client"

import { useState } from "react"
import "../css/Ems.css"

const EmsCategoryGrid = () => {
  const emsBrochurePathRW =
    "/BROCHURES/B-Ambulance Respiratory Systems (RW) (2024-06-10) (Rev. B).docx.pdf"
  const emsBrochurePathDL =
    "/BROCHURES/B-Ambulance Respiratory Systems (DL) (2024-06-10) (Rev. B).docx.pdf"

  const [version, setVersion] = useState("DL")
  const emsBrochurePath = version === "DL" ? emsBrochurePathRW : emsBrochurePathDL

  return (
    <div className="ems-page">
      <div className="layout-container">
        <div className="main-content">
          {/* Section Header */}
          <div className="section-header">
            <h2 className="product-title">Ambulance Respiratory Systems</h2>
            <div className="green-bar"></div>

            <div className="header-controls">
              <div className="brochure-toggle">
                <label>Brochure Version:</label>
                <select value={version} onChange={(e) => setVersion(e.target.value)} className="version-select">
                  <option value="RW">RW Version</option>
                  <option value="DL">DL Version</option>
                </select>
              </div>

              <a href={emsBrochurePath} download className="download-button">
                <svg className="download-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                Download Product Brochure
              </a>
            </div>
          </div>

          {/* Main Content Layout */}
          <div className="ems-flex-layout">
            {/* PDF Viewer Container */}
            <div className="pdf-viewer-container">
              <div className="pdf-iframe-wrapper">
                <iframe src={emsBrochurePath} title="Product Brochure PDF" className="pdf-iframe" />
              </div>
            </div>

            {/* Article Section */}
            <article className="ems-article">
              <h3 className="article-title">Product Overview</h3>
              <p className="article-description">
                Our Ambulance Respiratory Systems are designed for high performance in emergency medical environments.
                Flotec offers a vast selection of Quick connect fittings and combination packages for rapid and seamless integration into existing fleets of EMS vehicles.
                View our complete product brochure for DL and RW verisions.

              </p>

              <div className="features-section">
                <h4 className="features-title">Key Features:</h4>
                <ul className="custom-bullet-list">
                  <li className="custom-bullet-item">
                    <div className="custom-bullet"></div>
                    High-flow regulators and flowmeters
                  </li>
                  <li className="custom-bullet-item">
                    <div className="custom-bullet"></div>
                    Quick-connect fittings for rapid deployment
                  </li>
                  <li className="custom-bullet-item">
                    <div className="custom-bullet"></div>
                    Rugged, lightweight components
                  </li>
                  <li className="custom-bullet-item">
                    <div className="custom-bullet"></div>
                    Fully compatible with most U.S. EMS equipment
                  </li>
                </ul>
              </div>

              <div className="version-differences">
                <h4 className="version-differences-title">Version Differences</h4>
                <p className="version-differences-content">
                  <strong>RW Version:</strong> Optimized for cost effectiveness and functionality in standard EMS operations
                  <br />
                  <strong>DL Version:</strong> Enhanced durability for extended field operations
                </p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmsCategoryGrid
